<template>
  <StepsWrapper />
</template>

<script>
import StepsWrapper from "./components/StepsWrapper.vue";

export default {
  name: "App",
  components: {
    StepsWrapper,
  },
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";
#price-indicator {
  font-family: Open Sans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
</style>
